export default `{
  'type': hero._type,
  'title': hero.title,
  'heading': hero.heading,
  'introLine': hero.introLine,
  'briefParagraph': hero.briefParagraph,
}`;
